import React, { type ReactNode, type CSSProperties } from 'react';

import { type SizeType } from '../../features/config';

import TabsCards from './TabsCards/TabsCards';
import TabsLines from './TabsLines/TabsLines';

export type Tab = {
    key: string;
    label: ReactNode;
    children?: ReactNode;
    disabled?: boolean;
    disablePadding?: boolean;
    id?: string;
    className?: string;
};

type TabsBaseProps = {
    items: Tab[];
    type?: 'line' | 'card';
    activeKey?: string;
    onChange?: (activeKey: string) => void;
    defaultActiveKey?: string;
    destroyInactiveTabPane?: boolean;
    tabBarStyle?: CSSProperties;
};

export type TabsLinesProps = TabsBaseProps & {
    type?: 'line';
    orientation?: 'horizontal' | 'vertical';
    tabAlignment?: 'left' | 'right' | 'center';
    hideDivider?: boolean;
    tabsFullWidth?: boolean;
    hideTabBar?: boolean;
    fullHeight?: boolean;
    tabBarExtraContent?: { left?: ReactNode; right?: ReactNode };
    disableTabPanelPadding?: boolean;
    size?: SizeType;
    className?: string;
};

export type TabsCardsProps = TabsBaseProps & {
    type: 'card';
};

type TabsProps = TabsCardsProps | TabsLinesProps;

export const Tabs = ({ type = 'line', ...rest }: TabsProps) => {
    if (type === 'card') {
        return <TabsCards {...rest} />;
    }

    return <TabsLines {...rest} />;
};

export default Tabs;
